// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1XduJ","label":"Labeled_label__1oaoh","divider":"Labeled_divider__2z7nj"};